<div class="uploadChallan">
    <h1>Upload Challan</h1>
    <br/>
    <h5>Upload Files</h5>
    <span style="color:#53565A">PDF, JPG, JPEG, PNG. Max Size of 4.5 MB</span>
    <div type="file" class="inputBox" (change)="base($event)">
        Choose File
        <input style="opacity: 0.0; position: absolute; top: 130px; left: 10px; bottom: 0; right: 0; width: 20%; height:20%;" (change)="base($event)" type="file" id="file">
    </div>
    <br/>
    <!-- For PDF: simple link preview instead of embedded viewer -->
    <div *ngIf="this.type === 'application/pdf'" [ngClass]="{'viewChallanBox':this.pdfSrc.length > 0}">
        <img *ngIf="this.load==true" src="../../../../assets/images/buffering.gif" [ngClass]="{'viewLoader':this.load==true}" height="100px" width="100px"/>
        <a *ngIf="this.load==false && pdfSrc" [href]="pdfSrc" target="_blank">Open PDF in new tab</a>
    </div>

    <!-- For Image -->
    <div *ngIf="this.type !== 'application/pdf'">
        <img *ngIf="this.load==true" src="../../../../assets/images/buffering.gif" [ngClass]="{'viewLoader':this.load==true}" height="100px" width="100px"/>
        <img *ngIf="this.load==false" [src]="url" [ngClass]="{'viewImageBox':this.url.length > 0}"/><br/>
    </div>

    <div class="d-flex justify-content-end" style="margin-top:15px;margin-right: -10px">
        <button (click)="Cancel()" class="button" type="button" style="background-color: #53565A;color:#fff">
            Cancel
        </button>
        <button (click)="Submit()" class="button" type="button blue" [disabled]="!(this.pdfSrc.length > 0 || this.url.length > 0)" style="background: #007CB0;color:#fff">Upload</button>
    </div>
</div>